import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const TakingsPage = lazy(() => import("./web/TakingsPage.js").then((m) => ({ default: m.TakingsPage })));
const MachinesPage = lazy(() => import("./web/MachinesPage.js").then((m) => ({ default: m.MachinesPage })));
const SnapPage = lazy(() => import("./web/SnapPage.js").then((m) => ({ default: m.SnapPage })));
const ImportsPage = lazy(() => import("./web/ImportsPage.js").then((m) => ({ default: m.ImportsPage })));

export default defineWebModule({ manifest, pages: { "": TakingsPage, "/machines": MachinesPage, "/imports": ImportsPage, "/snap": SnapPage } });
